import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {Item} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';

import {
    UsersGroupsSearchResultController,
    UsersGroupsSearchResultView,
    userSearchResultStateActions,
    userSearchResultStateSelector,
} from '../users-groups-search-result';

import {ConferenceUsersToolsRibbon} from './components/conference-users-tools-ribbon';
import {Header} from './components/header';

export const ConferenceUsersTabWrapper = () => {
    const queryParams = useParams<{accountId: string, userType?: string}>();
    const accountId = queryParams.accountId;

    const dispatch = useDispatch();
    const cacheKeys = useSelector(userSearchResultStateSelector);

    useEffect(() => {
        if (accountId) {
            dispatch(userSearchResultStateActions.setSearchCriteria({
                virtualUsers: true,
                accountIds: [+accountId],
            }));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!accountId || !cacheKeys.searchCriteria.accountIds) {
        return null;
    }

    return (
        <ConferenceUsersTab accountId={+accountId}/>
    );
};

const PLACE = 'Conference Users';

type Props = {
    accountId: number,
};

const ConferenceUsersTab = ({accountId}: Props) => (
    <UsersGroupsSearchResultController place={PLACE}>
        {props => (
            <Item grow={1}>
                <Header onAddAttendee={props.refreshResults}/>
                <StickyElement className="sticky-tool-ribbon">
                    <ConferenceUsersToolsRibbon
                        accountId={accountId}
                        place={PLACE}
                        adminId={props.adminId}
                        isLoading={props.isLoading}
                        getAllEntityIds={props.getAllEntityIds}
                        templates={props.templates}
                        activeSearchTemplate={props.activeSearchTemplate}
                        setActiveSearchTemplate={props.setActiveSearchTemplate}
                        loadTemplates={props.loadTemplates}
                        refreshResults={props.refreshResults}
                        loadActiveSearchTemplate={props.loadActiveSearchTemplate}
                    />
                </StickyElement>
                <UsersGroupsSearchResultView
                    getAllEntityIds={props.getAllEntityIds}
                    place={PLACE}
                    activeSearchTemplate={props.activeSearchTemplate}
                />
            </Item>
        )}
    </UsersGroupsSearchResultController>
);
